import { PRODUCTS } from "../../types/ProductType";

import axios from "axios";

const getAllProductAction = (data) => {
	return {
		type: PRODUCTS,
		payload: data,
	};
};

export const loadProduct = ({ page, limit, status }) => {
	//dispatching with an call back function and returning that
	return async (dispatch) => {
		try {
			const { data } = await axios.get(
				`product?status=${status}&page=${page}&count=${limit}`
			);
			//dispatching data
			dispatch(getAllProductAction(data));
		} catch (error) {
			console.log(error.message);
		}
	};
};

export const searchRunningSize = (searchTerm) => {
	return async (dispatch) => {
		try {
			const { data } = await axios.get(`running-size?query=all`);
			const s = searchTerm.toLowerCase();
			const filtered = data.filter((item) => {
				return (
					(item.name && item.name.toLowerCase().includes(s)) ||
					(item.customer?.name && item.customer.name.toLowerCase().includes(s)) ||
					(item.product_sub_category?.name && item.product_sub_category.name.toLowerCase().includes(s)) ||
					(item.unit_type && item.unit_type.toLowerCase().includes(s)) ||
					(item.id && item.id.toLowerCase().includes(s)) ||
					(item.length && String(item.length).includes(s)) ||
					(item.width && String(item.width).includes(s)) ||
					(item.height && String(item.height).includes(s))
				);
			});
			dispatch(getAllProductAction(filtered));
			return filtered.length;
		} catch (error) {
			console.log(error.message);
		}
	};
};

export const loadRunningSize = ({ page, limit, status }) => {
	//dispatching with an call back function and returning that
	return async (dispatch) => {
		try {
			const { data } = await axios.get(
				`running-size?status=${status}&page=${page}&count=${limit}`
			);
			// Backend returns { data: [...], total } for paginated responses
			if (data && data.data) {
				dispatch(getAllProductAction(data.data));
				return data.total;
			} else {
				dispatch(getAllProductAction(data));
			}
		} catch (error) {
			console.log(error.message);
		}
	};
};
